export enum LoginError {
  INVALID_EMAIL,
  INVALID_PASSWORD,
  USER_DISABLED,
  USER_NOT_FOUND,
  UNKNOWN,
  /** Happens because of very slow or no internet connection when timeout kicks in */
  NETWORK_REQUEST_FAILED,

  // Register with email/pass
  EMAIL_ALREADY_IN_USE,
  OPERATION_NOT_ALLOWED,
  WEAK_PASSWORD,

  // Sign in with Popup
  EXISTS_WITH_DIFFERENT_CREDENTIAL,

  /**
   * The password was right and the account also carries a second factor. Not a
   * failure — the sign-in is half-finished and waiting for a code.
   */
  MFA_REQUIRED,

  /** Firebase throttled the account or the device after repeated failures. */
  TOO_MANY_REQUESTS,
  /** The person closed the Google / company sign-in window: not an error. */
  POPUP_CLOSED,
  /** The browser stopped the sign-in window from opening. */
  POPUP_BLOCKED
}
